import {
    GET_ERRORS
} from './type';
import Products from '../Models/Products';

export const buyerAskEstimation = (buyerData, history) => dispatch => {
    // let i=[];
    var x = JSON.parse(localStorage.getItem('info'))
    Products.saveRequest(buyerData).then(res => {
            if (parseInt(res.data.status) === 200) {
                if (x.user_type_id === 1) {
                    history.push('/buyer-estimate');
                } else if (x.user_type_id === 2) {
                    history.push('/seller-buyer-estimate');
                }else if (x.user_type_id === 3) {
                    history.push('/affiliator-buyer-estimate');
                }
            } else {
                dispatch({
                    type: GET_ERRORS,
                    payload: res.data.message
                })
            }

        })
        .catch(
            // dispatch({
            //     type: GET_ERRORS,
            //     payload: res.data.message
            // })
            // err=>this.setState({errors:err.response.data})
        )
    // return {
    //     type: SELLER_LOGIN,
    //     payload: sellerData,
    // }
};